import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import EventItem from './EventItem/EventItem';
import DoneItem from './DoneItem/DoneItem';
import ModernCalendar from './Calendar/Calendar';
import CalendarHeader from './CalendarHeader/CalendarHeader';
import Fab from './Fab/Fab';

import calendar from '../../../assets/icons/calendar.svg';
import setting from '../../../assets/icons/setting.svg';

import './Mobile.css';

export default class Mobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDuties: false,
      openReminder: false,
      openEvents: false,
      openFab: false,
    }
  }

  setOpenDuties = () => {
    this.setState({
      openDuties: true,
    })
  }

  submitDuties = () => {
    this.setState({
      openDuties: false,
    })
  }

  setOpenEvents = () => {
    this.setState({
      openDuties: true,
    })
  }

  submitEvents = () => {
    this.setState({
      openDuties: false,
    })
  }

  setOpenReminder = () => {
    this.setState({
      openReminder: true,
    })
  }

  submitDuties = () => {
    this.setState({
      openDuties: false,
    })
  }

  setOpenFab = () => {
    this.setState({
      openFab: !this.state.openFab,
    })
  }
  render() {
    const { events, doneList, religious_times, monasebat, selectedDay, setSelectedDay, addDone, deleteDone } = this.props;
    return (
      <Fragment>
        <div className={this.state.openFab ? 'mobile-home mobile-home-blur d-flex flex-column' : 'mobile-home d-flex flex-column'}>
          <div className="mobile-home__top d-flex flex-column">
            <div className="calendar__header d-flex">
              <CalendarHeader date={selectedDay} />
              <div className="mobile-home__top--buttons d-flex">
                <Link to="/year"><img src={calendar} /></Link>
                <Link to="/setting"><img src={setting} /></Link>
              </div>
            </div>
            <ModernCalendar headerAccess={false} setSelectedDay={setSelectedDay} />
            <div className="mobile-home__top--events d-flex flex-column">
              {
                monasebat.map(item => (
                  <div key={item.id} style={{ borderColor: item.color }} className="d-flex">
                    <span style={{ border: "2px solid" + item.color, borderRadius: 2, backgroundColor: item.color }}></span>
                    <div className="mt-1">{item.name}</div>
                  </div>
                ))
              }
            </div>
            <div className="mobile-home__top--times d-flex">
              {
                religious_times.map(item => (
                  <div className="mobile-top__time d-flex flex-column" key={item.name}>
                    <div>{item.name}</div>
                    <strong>{item.value}</strong>
                  </div>
                ))
              }
            </div>
          </div>
          <div className="mobile-home__middle">
            {
              events.map(item => (
                <EventItem event={item} addDone={addDone} key={item.id} />
              ))
            }
          </div>
          <div className="mobile-home__bottom">
            <h1>انجام شده</h1>
            {
              doneList.map(item => (
                <DoneItem event={item} deleteDone={deleteDone} key={item.id} />
              ))
            }
          </div>
          {!this.state.openFab ?
            <div className="mobile-home__add">
              <span onClick={() => this.setOpenFab()}>+</span>
            </div> : null
          }
        </div>
        {this.state.openFab ? <Fab setOpenFab={this.setOpenFab} /> : null}
      </Fragment>
    );
  }
}
